import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import momentLocalizer from 'react-widgets-moment'
import adicionarFiltroCentroCusto from '../../actions/centro-custo/adicionarFiltroCentroCusto'
import removerFiltroCentroCusto from '../../actions/centro-custo/removerFiltroCentroCusto'
import FiltroBusca from '../comum/FiltroBusca'
import 'react-widgets/dist/css/react-widgets.css';

momentLocalizer();

export class FiltroBuscaCentroCusto extends Component {
  render () {
    if (!this.props.filtrosAdicionados) {
      return <div>Carregando...</div>
    }
    return (
      <FiltroBusca
        filtrosAdicionados={this.props.filtrosAdicionados}
        filtro={this.props.filtro}
        opcoes={this.props.opcoes}
        isCpf={this.props.isCpf}
        isNome={this.props.isNome}
        isRadio={this.props.isRadio}
        isFiltroData={this.props.isFiltroData}
        isFiltroHora={this.props.isFiltroHora}
        isNumero={this.props.isNumero}
        adicionarFiltro={this.props.adicionarFiltroCentroCusto}
        removerFiltro={this.props.removerFiltroCentroCusto}
      />
    )
  }
}

export const mapStateToProps = state => ({
  filtrosAdicionados: state.filtrosAdicionadosCentroCusto
})

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    adicionarFiltroCentroCusto,
    removerFiltroCentroCusto,
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroBuscaCentroCusto)

